import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';

@Pipe({
  name: 'isGoogle'
})
export class IsGooglePipe implements PipeTransform {
 
  transform(reviewTarget: ReviewTargetModel): boolean {
    return !!reviewTarget.name && reviewTarget.name.toLocaleLowerCase().includes('google')
  }

}
